import { render, staticRenderFns } from "./inspectionAreas.vue?vue&type=template&id=2a30e444"
import script from "./inspectionAreas.vue?vue&type=script&lang=js"
export * from "./inspectionAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports